import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/Card'
import { Button } from '@/components/ui/button'
import { EnvelopeIcon } from '@heroicons/react/16/solid'
import RegisterFooter from './RegisterFooter'
import { Link } from 'react-router-dom'
import { GoogleOAuthProvider } from '@react-oauth/google'
import GoogleLogin from '../login/GoogleLogin'
import useGetSocialAppId from '@/services/api/auth/useGetSocialAppId.ts'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import FacebookLoginButton from '../login/FacebookLoginButton'
import XeroLoginButton from '../login/XeroLoginButton'
import { socialButtonClass } from '../login/socialSignInStyles'

export default function RegisterPage() {
  const navigate = useNavigate()
  const { data: googleApp, isLoading: isLoadingGoogleApp } = useGetSocialAppId({
    platform: 'google',
  })

  const [googleAuthInProgress, setGoogleAuthInProgress] = useState(false)
  const [facebookAuthInProgress, setFacebookAuthInProgress] = useState(false)

  if (isLoadingGoogleApp) return 'Loading...'

  return (
    <div className="pf-auth grid min-h-screen">
      <Card className="place-self-center">
        <CardHeader>
          <CardTitle>Create your account</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid gap-3">
            <GoogleOAuthProvider clientId={googleApp?.platform_id}>
              <GoogleLogin
                isLoading={googleAuthInProgress}
                setIsLoading={setGoogleAuthInProgress}
                label="Sign up with Google"
                onSuccess={() => {
                  navigate('/')
                }}
              />
            </GoogleOAuthProvider>
            <FacebookLoginButton
              isLoading={facebookAuthInProgress}
              setIsLoading={setFacebookAuthInProgress}
              label="Sign up with Facebook"
              onSuccess={() => {
                navigate('/')
              }}
            />
            <XeroLoginButton label="Sign up with Xero" />
            <Link
              to="/register/email"
              className="text-txt-secondary no-underline"
            >
              <Button variant="outline" size="lg" className={socialButtonClass}>
                <EnvelopeIcon className="size-5 text-txt-primary" />
                <span>Sign up with Email</span>
              </Button>
            </Link>
          </div>
        </CardContent>
        <CardFooter>
          <RegisterFooter />
        </CardFooter>
      </Card>
    </div>
  )
}
